import { BookmarkWithClips, OrganizationResponse } from "@/api/bookmarkClipShares";
import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";

dayjs.extend(advancedFormat);

type CsvRow = [
  clipTitle: string,
  description: string,
  keyword: string,
  channelDetails: string,
  meetingTitle: string,
  publishDate: string,
  transcriptSnippet: string,
  url: string,
  timestamp: string
];

export const getMeetingUrl = (meetingId: number, transcriptId: string, keyword: string) => {
  return `${window.location.origin}/meetings/${meetingId}?search-terms=${keyword}&transcript_id=${transcriptId}`
}

export const exportToCsv = (bookmark: BookmarkWithClips) => {
  const headers = [
    [
      '"Clip Title"',
      '"Description"',
      '"Keyword"',
      '"Channel Details"',
      '"Meeting Title"',
      '"Publish Date"',
      '"Transcript Snippet"',
      '"URL"',
      '"Timestamp"',
    ],
  ]
  const content: CsvRow[] = []
  bookmark?.clips.forEach((clip) => {
    const urlSearchParams = new URLSearchParams()
    urlSearchParams.set(
      "startTimeSeconds",
      clip.start_time_in_seconds ? (parseInt(clip.start_time_in_seconds.toString()) - 5).toString() : "0",
    )
    const url = clip.raw_text
      ? `${window.location.origin}/share/${clip.id}?type=clip`
      : `${window.location.origin}/share/${clip?.meeting?.id}`
    if (clip.organization) {
      content.push([
        `"${clip?.title || ""}"`,
        `"${clip?.description || ""}"`,
        `"${clip.keyword}"`,
        `"${formatChannelDetails(clip.organization)}"`,
        `"${clip.title}"`,
        `"${formatDate(clip.meeting.published_at)}"`,
        `"${clip.raw_text}"`,
        `"${url}"`,
        `"${formatSeconds(clip?.start_time_in_seconds)}"`,
      ])
    }
  })
  const rows = [...headers, ...content]
  rowsToCsvDownload(rows, bookmark.title)
}

const rowsToCsvDownload = (rows: string[][], title: string) => {
  const csvContent = `${rows.map((r) => r.join(",")).join("\n")}`
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8," })
  const url = URL.createObjectURL(blob)
  const link = document.createElement("a")
  link.setAttribute("href", url)
  link.setAttribute("download", `${title.replace(/ /g, "_")}.csv`)
  link.click()
}

const formatDate = (datetime: string) => {
  const dayjsDate = dayjs(datetime);
  if (dayjsDate.isValid() === false) {
    return "";
  }

  return dayjs(datetime, "YYYY-MM-DDTh:mm:ss").format("MMMM Do YYYY");
}

// TODO: whoever has to consume this function, please rewrite it.
export const formatSeconds = (seconds: number) => {
  try {
    return new Date(seconds * 1000).toISOString().substr(11, 8)
  } catch (_e) {
    return ""
  }
}

const formatChannelDetails = (organization: OrganizationResponse) => {
  let text = `${organization.name} in `
  if (organization.city) {
    text += `in ${organization.city.name}, `
  } else if (organization.county) {
    text += `in ${organization.county.name}, `
  }

  if (organization?.state?.name) {
    text += `${organization.state.name}`
  }

  return text
}